export default __webpack_public_path__ + "static/media/huntinghawk.6e91aca7.png";